/** @jsxImportSource react */
import type { SVGProps } from 'react';
const Eye = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.5 12.125a3.5 3.5 0 1 0 7 0 3.5 3.5 0 0 0-7 0m-.036 3.536a5 5 0 1 1 7.071-7.071 5 5 0 0 1-7.07 7.07"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.146 10.447c-.462.734-.646 1.323-.646 1.678s.184.944.646 1.678c.45.713 1.119 1.492 1.974 2.214C6.83 17.46 9.228 18.625 12 18.625s5.169-1.164 6.88-2.608c.855-.721 1.524-1.5 1.974-2.214.462-.734.646-1.323.646-1.678s-.184-.944-.646-1.678c-.45-.714-1.119-1.492-1.974-2.214C17.17 6.79 14.772 5.625 12 5.625S6.831 6.789 5.12 8.233c-.855.722-1.524 1.5-1.974 2.214m1.006-3.36C6.073 5.466 8.802 4.125 12 4.125c3.199 0 5.927 1.341 7.848 2.962.961.811 1.735 1.705 2.275 2.56.526.836.877 1.713.877 2.478s-.35 1.642-.877 2.478c-.54.856-1.314 1.749-2.275 2.56-1.921 1.621-4.65 2.962-7.848 2.962-3.199 0-5.927-1.341-7.848-2.962-.961-.811-1.735-1.704-2.275-2.56C1.351 13.767 1 12.89 1 12.125s.35-1.642.877-2.478c.54-.855 1.314-1.749 2.275-2.56"
      clipRule="evenodd"
    />
  </svg>
);
export default Eye;
